import { REQUEST_USERS_LIST, SET_USERS_LIST, SET_PAGE, REQUEST_DELETE_USER } from './constants'

export function requestUsersList(page = 1, filter = '') {
    return {
        type: REQUEST_USERS_LIST,
        payload: {
            page,
            filter
        }
    }
}

export function setUsersList({ users, pagination }) {
    return {
        type: SET_USERS_LIST,
        payload: {
            users,
            pagination
        }
    }
}

export function setPage({ page }) {
    return {
        type: SET_PAGE,
        payload: {
            page
        }
    }
}

export function requestUserDelete({ userId, filter }) {
    return {
        type: REQUEST_DELETE_USER,
        payload: {
            userId,
            filter
        }
    }
}
